import { Row, Col } from "antd";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";
import i18n from "i18next";
import {
  FooterSection,
  Title,
  Para,
  Large,
  Chat,
  Empty,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
} from "./styles";

import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  return (
    <FooterSection>
      <Container className="footer">
        <Row justify="space-between">
          <Col lg={10} md={10} sm={12} xs={12}>
            <Language>{i18n.t("footerContactTtitle")}</Language>
            <a href="mailto:info@t2consult.net">
              <Chat>{t("footerLetsChat")}</Chat>
            </a>
          </Col>
          <Col lg={8} md={8} sm={12} xs={12}>
            <Title>{i18n.t("footerPolicyTitle")}</Title>
            <Large to="/Privacy">
              {i18n.t("footerPolicyLinkApplicationSecurity")}
            </Large>
            <Large to="/sla">
              {i18n.t("footerPolicyLinkSoftwarePrinciples")}
            </Large>
            <Large to="/eula">
              {i18n.t("footerPolicyLinkSoftwareEndUserAgreement")}
            </Large>
          </Col>
          <Col lg={6} md={6} sm={12} xs={12}>
            <Empty />
            <Large to="/">{i18n.t("footerSupportCenter")}</Large>
            <Large to="/">{i18n.t("footerCustomerSupport")}</Large>
          </Col>
        </Row>
        <Row justify="space-between">
          <Col lg={10} md={10} sm={12} xs={12}>
            <Language>{i18n.t("footerAddressTitle")}</Language>
            <Para>{i18n.t("footerAddressStreet")}</Para>
            <Para>{i18n.t("footerAddressZipCity")}</Para>
            <Para>{i18n.t("footerAddressCountry")}</Para>
          </Col>
          <Col lg={8} md={8} sm={12} xs={12}>
            <Title>{i18n.t("footerCompanyTitle")}</Title>
            <Large to="/">{i18n.t("footerCompanyAbout")}</Large>
            <Large to="/">{i18n.t("footerCompanyCareer")}</Large>
            <Large to="/imprint">{i18n.t("footerPolicyLinkImprint")}</Large>
          </Col>
          <Col lg={6} md={6} sm={12} xs={12}>
            <Label htmlFor="select-lang">{i18n.t("footerLanguage")}</Label>
            <LanguageSwitchContainer>
              <LanguageSwitch onClick={() => handleChange("en")}>
                <SvgIcon
                  src="united-states.svg"
                  aria-label="homepage"
                  width="30px"
                  height="30px"
                />
              </LanguageSwitch>

              <LanguageSwitch onClick={() => handleChange("de")}>
                <SvgIcon
                  src="germany.svg"
                  aria-label="homepage"
                  width="30px"
                  height="30px"
                />
              </LanguageSwitch>
            </LanguageSwitchContainer>
          </Col>
        </Row>
      </Container>
    </FooterSection>
  );
};

export default Footer;
